import Language, { fallbackLanguageCode, normalizeLanguageCode } from '@/store/models/Language';
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
    setup() {
        const { locale } = useI18n({
            useScope: 'global',
        });
        const store = useStore();
        const route = useRoute();
        const loading = computed(() => store.getters.loadingLanguage);
        const selectedLanguage = computed({
            get: () => normalizeLanguageCode(locale.value),
            set: (value: string) => {
                locale.value = normalizeLanguageCode(value);
            },
        });
        const languages = computed(() => {
            if (route.query.showKeys) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                locale.value = 'keys';
                return [new Language({ languageCode: 'keys' })];
            }
            const availableLanguages = store.getters.languages ?? [];
            return availableLanguages.some((language: Language) => language.languageCode === fallbackLanguageCode)
                ? availableLanguages
                : [new Language(), ...availableLanguages];
        });

        const languageChange = async (event: { target: HTMLSelectElement }) => {
            const language: Language = store.getters.language;

            if (route.params.reportAlias && language.reportAlias) {
                await store.dispatch(
                    'setLanguage',
                    new Language({
                        languageCode: event.target.value,
                        knowledgeModelAlias: language.knowledgeModelAlias,
                        knowledgeModelName: language.knowledgeModelName,
                        instrumentAlias: language.instrumentAlias,
                        section: 'reports',
                        reportAlias: language.reportAlias,
                    }),
                );
            }

            await store.dispatch(
                'setLanguage',
                new Language({
                    languageCode: event.target.value,
                    knowledgeModelAlias: language.knowledgeModelAlias,
                    knowledgeModelName: language.knowledgeModelName,
                    section: language.section,
                    reportAlias: language.reportAlias,
                }),
            );

            await store.dispatch(
                'setLanguage',
                new Language({
                    languageCode: event.target.value,
                    knowledgeModelAlias: language.knowledgeModelAlias,
                    knowledgeModelName: language.knowledgeModelName,
                    instrumentAlias: language.instrumentAlias,
                    section: language.section,
                    reportAlias: language.reportAlias,
                }),
            );

            if (language.instrumentAlias === 'demographic_data') {
                const instrumentAlias = language.instrumentAlias;

                await store.dispatch(
                    'setLanguage',
                    new Language({
                        languageCode: event.target.value,
                        knowledgeModelAlias: language.knowledgeModelAlias,
                        knowledgeModelName: language.knowledgeModelName,
                        instrumentAlias: 'epsi-combined',
                        section: language.section,
                        reportAlias: language.reportAlias,
                    }),
                );

                await store.dispatch(
                    'setLanguage',
                    new Language({
                        languageCode: event.target.value,
                        knowledgeModelAlias: language.knowledgeModelAlias,
                        knowledgeModelName: language.knowledgeModelName,
                        instrumentAlias: instrumentAlias,
                        section: language.section,
                        reportAlias: language.reportAlias,
                    }),
                );
            }
        };

        return {
            languages,
            languageChange,
            selectedLanguage,
            loading,
        };
    },
});
